/* eslint-disable */

import { HiX } from "react-icons/hi";
import { FiAlignJustify } from "react-icons/fi";
import Links from "./components/Links";
import routes from "routes";
import { getUser } from "auth/Authentication";
import { handleRouteRestriction } from "utils/general-utils";
import { User } from "models/user-models";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Sidebar = (props: {
  open: boolean;
  onClose: React.MouseEventHandler<HTMLSpanElement>;
  onToggle?: () => void;
}) => {
  const { open, onClose, onToggle } = props;
  const [user, setUser] = useState(null);
  const [trialExpire, setTrialExpire] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    let local_user = getUser();
    setUser(local_user);
    const hasTrialExpired = (expirationTimeUTC: any) => {
      const currentTimeUTC = new Date().toISOString(); // Get current time in UTC
      return currentTimeUTC > expirationTimeUTC; // Compare current time with expiration time
    };
    if (hasTrialExpired(local_user.trial_expiry)) {
      setTrialExpire(true);
    }
  }, [navigate]);

  return (
    <div
      className={`sm:none duration-175 slidebar-scroller linear fixed !z-50 h-full overflow-y-auto overflow-x-hidden bg-surfacePrimary text-textPrimary shadow-2xl transition-all md:!z-50 lg:!z-50 xl:!z-0 ${
        open
          ? "w-[313px] translate-x-0"
          : "-translate-x-96 xl:w-[80px] xl:translate-x-0"
      }`}
      style={{ direction: "rtl" }}
    >
      <div
        style={{ direction: "ltr" }}
        className="flex min-h-full flex-col pb-10"
      >
        <span
          className="absolute right-4 top-4 block cursor-pointer text-textSecondary hover:text-textPrimary xl:hidden"
          onClick={onClose}
        >
          <HiX />
        </span>

        <div
          className={`mt-[50px] box-border flex items-center ${
            open ? "mx-[32px] justify-between" : "mx-auto justify-center"
          }`}
        >
          <div
            className={`ml-1 h-2.5 font-poppins text-[24px] font-bold leading-tight tracking-tight text-textPrimary ${
              open ? "block" : "hidden"
            }`}
          >
            Express Chart Note
          </div>
          <span
            className="relative top-2 hidden cursor-pointer text-xl text-gray-600 dark:text-white xl:block"
            onClick={onToggle || onClose}
          >
            <FiAlignJustify className="h-5 w-5" />
          </span>
        </div>
        <div className="mb-7 mt-[58px] h-px bg-borderPrimary" />
        {/* Nav item */}

        <ul className="mb-auto overflow-x-hidden pt-1">
          <Links
            open={open}
            routes={routes.filter(
              (x) =>
                x.path !== "add-subcategory/:id" &&
                x.path !== "register" &&
                x.path !== "success" &&
                x.path !== "sign-in" &&
                x.path !== "changePassword" &&
                x.path !== "forgotpass" &&
                x.path !== "AccessDenied" &&
                x.path !== "404"
            )}
          />
        </ul>

        {/* Nav item end */}
        <div
          className={`mb-7 mt-[58px] h-px bg-borderPrimary ${
            open ? "pl-5" : "px-2 text-center"
          } `}
        >
          <div className={`${open ? "block" : "hidden"}`}>
            {user?.type === "2" && user?.hasOwnProperty("expiryTime") ? (
              user.expiryTime ? (
                <h1 className="pt-3 font-poppins font-medium text-brand-500">
                  Subscription is Active
                </h1>
              ) : (
                <h1 className="pt-3 font-poppins font-medium text-brand-500">
                  Subscription is Finsihed
                </h1>
              )
            ) : user?.type === "2" && trialExpire ? (
              <h1 className="pt-3 font-poppins font-medium text-brand-500">
                7 day trial is finished
              </h1>
            ) : (
              user?.type === "2" && (
                <h1 className="pt-3 font-poppins font-medium text-brand-500">
                  7 day trial is active
                </h1>
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
